import { Input } from 'antd';
import { FormattedMessage } from 'react-intl';
import { ValuationLevel, Valuation as ValuationData } from '../../../api/btlApplicationForm/valuationTypes';
import { formatDate } from '../../../utils/dates';
import dayjs from 'dayjs';

const formatValuationLevel = (level?: ValuationLevel): string => {
  if (!level) return '';
  const levelMap: Record<ValuationLevel, string> = {
    [ValuationLevel.ONE]: 'Level 1',
    [ValuationLevel.TWO]: 'Level 2',
    [ValuationLevel.THREE]: 'Level 3',
  };
  return levelMap[level];
};

const formatCurrency = (value?: number | null): string => {
  if (value === null || value === undefined) return '';
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

interface ValuationProps {
  valuation: ValuationData | null | undefined;
  showTitle?: boolean;
}

export const Valuation = ({ valuation, showTitle = true }: ValuationProps) => {
  const valuationData = valuation || null;

  return (
    <div className={'w-full'}>
      {showTitle && (
        <h5 className={'mt-0 mb-4'}>
          <FormattedMessage id={'applicationDetails.valuation.title'} />
        </h5>
      )}

      <div className={'grid grid-cols-1 md:grid-cols-2 gap-6'}>
        <div>
          <label className={'block text-sm font-medium text-gray-700 mb-2'}>
            <FormattedMessage id={'btlApplicationForm.VALUATION.instructedDate.label'} />
          </label>
          <Input
            value={formatDate(valuationData?.instructionDate)}
            variant={'filled'}
            readOnly
            className={'pointer-events-none'}
          />
        </div>

        <div>
          <label className={'block text-sm font-medium text-gray-700 mb-2'}>
            <FormattedMessage id={'btlApplicationForm.VALUATION.bookedDate.label'} />
          </label>
          <Input
            value={formatDate(valuationData?.instructionBookedDate)}
            variant={'filled'}
            readOnly
            className={'pointer-events-none'}
          />
        </div>

        <div>
          <label className={'block text-sm font-medium text-gray-700 mb-2'}>
            <FormattedMessage id={'btlApplicationForm.VALUATION.inspectionDate.label'} />
          </label>
          <Input
            value={formatDate(valuationData?.inspectionDate)}
            variant={'filled'}
            readOnly
            className={'pointer-events-none'}
          />
        </div>

        <div>
          <label className={'block text-sm font-medium text-gray-700 mb-2'}>
            <FormattedMessage id={'btlApplicationForm.VALUATION.reportDate.label'} />
          </label>
          <Input
            value={formatDate(valuationData?.reportDate)}
            variant={'filled'}
            readOnly
            className={'pointer-events-none'}
          />
        </div>

        <div>
          <label className={'block text-sm font-medium text-gray-700 mb-2'}>
            <FormattedMessage id={'btlApplicationForm.VALUATION.reportReceivedDate.label'} />
          </label>
          <Input
            value={formatDate(valuationData?.reportReceivedDate)}
            variant={'filled'}
            readOnly
            className={'pointer-events-none'}
          />
        </div>

        <div>
          <label className={'block text-sm font-medium text-gray-700 mb-2'}>
            <FormattedMessage id={'btlApplicationForm.VALUATION.expiryDate.label'} />
          </label>
          <Input
            value={formatDate(dayjs(valuationData?.inspectionDate).add(6, 'months').toDate())}
            variant={'filled'}
            readOnly
            className={'pointer-events-none'}
          />
        </div>

        <div>
          <label className={'block text-sm font-medium text-gray-700 mb-2'}>
            <FormattedMessage id={'btlApplicationForm.VALUATION.valuationType.label'} />
          </label>
          <Input
            value={formatValuationLevel(valuationData?.level)}
            variant={'filled'}
            readOnly
            className={'pointer-events-none'}
          />
        </div>

        <div>
          <label className={'block text-sm font-medium text-gray-700 mb-2'}>
            <FormattedMessage id={'btlApplicationForm.VALUATION.valuationAmount.label'} />
          </label>
          <Input
            value={formatCurrency(valuationData?.valuationAmount)}
            variant={'filled'}
            readOnly
            className={'pointer-events-none'}
          />
        </div>

        <div>
          <label className={'block text-sm font-medium text-gray-700 mb-2'}>
            <FormattedMessage id={'btlApplicationForm.VALUATION.reinstatementAmount.label'} />
          </label>
          <Input
            value={formatCurrency(valuationData?.reinstatementCost)}
            variant={'filled'}
            readOnly
            className={'pointer-events-none'}
          />
        </div>
      </div>
    </div>
  );
};
